import { Context, createContext, useContext } from 'react';

export type ModalContextType<ModalType extends string> = {
  showModal: (type: ModalType) => void;
  hideModal: () => void;
  isModalOpen: (modalTypeToCheck: ModalType) => boolean;
};

export const ModalContext = createContext<ModalContextType<string> | undefined>(
  undefined,
);

export const useModal = <ModalType extends string>() => {
  const context = useContext<ModalContextType<ModalType>>(
    ModalContext as unknown as Context<ModalContextType<ModalType>>,
  );
  if (context === undefined) {
    throw new Error('useModal must be used within a ModalContextProvider');
  }

  return context;
};
